module.exports = __webpack_public_path__ + "assets/images/invisible-asia/5-india.jpg?v=b0660044";